module.exports = __webpack_public_path__ + "img/closed_handle_box2.b66a410b.png";